// return data from the store, act similar as computed variable
const moduleGetters = {
  getRooms: state => {
    return state.rooms;
  },
  getRoom: state => roomId => {
    return state.rooms[roomId];
  }
};

export default moduleGetters;
